import { useState, useEffect } from 'react';
import { supabase } from '../lib/supabase';

const DEFAULT_SETTINGS = {
  calc_title: 'حاسبة الجمركة',
  calc_subtitle: 'الرجاء اختيار الماركة والموديل لمعرفة تكلفة جمركة السيارات المستوردة.',
  cars_title: 'السيارات المقترحة',
  cars_subtitle: 'أحدث العروض المتوفرة للبيع.',
  navbar_logo_size: '40', // حجم اللوجو الافتراضي
  reviews_location: 'home_above_cars', // مكان عرض المراجعات الافتراضي
};

export const useSiteSettings = () => {
  const [settings, setSettings] = useState(DEFAULT_SETTINGS);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchSettings();
  }, []);

  const fetchSettings = async () => {
    try {
      const { data } = await supabase.from('site_settings').select('setting_key, setting_value');
      if (data && data.length > 0) {
        const mapped = { ...DEFAULT_SETTINGS };
        data.forEach(row => {
          if (row.setting_key in mapped) mapped[row.setting_key] = row.setting_value;
        });
        setSettings(mapped);
      }
    } catch (err) {
      console.warn('Could not load site settings.', err);
    } finally {
      setLoading(false);
    }
  };

  return { settings, loading, refetch: fetchSettings };
};

export const useFavicon = () => {
  useEffect(() => {
    const applyFavicon = async () => {
      try {
        const { data } = await supabase.from('site_settings').select('setting_value').eq('setting_key', 'site_favicon_url').single();
        if (data?.setting_value) {
          let link = document.querySelector("link[rel~='icon']");
          if (!link) {
            link = document.createElement('link');
            link.rel = 'icon';
            document.head.appendChild(link);
          }
          link.href = data.setting_value;
        }
      } catch (_) {}
    };
    applyFavicon();
  }, []);
};